import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useUserLoggedIn} from './userContext';
import {WeatherService} from '../api';
import {WeatherStationFromList} from '../api/types';
import {
  getUserStationIds,
  setFavoriteStationList,
  setStationList,
} from '../store';
import useApiClient from './useApiClient';

const useFetchStationList = () => {
  const {fetch, loading} = useApiClient();
  const dispatch = useDispatch();
  const isLoggedIn = useUserLoggedIn();
  const userStationIds = useSelector(getUserStationIds);

  const fetchStationList = React.useCallback(() => {
    fetch(WeatherService.myStationList(userStationIds))
      .then((data: WeatherStationFromList[]) => {
        if (isLoggedIn) {
          // Synchronize Favorite Station list only for logged-in users
          dispatch(
            setFavoriteStationList(data.filter((item) => item.favorite)),
          );
        }
        dispatch(setStationList(data));
      })
      .catch(() => {});
  }, [userStationIds, fetch, isLoggedIn, dispatch]);

  return React.useMemo(
    () => ({
      fetchStationList,
      loading,
    }),
    [fetchStationList, loading],
  );
};

export default useFetchStationList;
